export default __webpack_public_path__ + "static/media/BLR-40.b82d0eee.JPG";